import { URL_OR_EMAIL_PATTERN } from './globals';

export function containsUrlOrEmail(subject?: string | null): boolean {
    if (!subject) {
        return false;
    }

    return new RegExp(URL_OR_EMAIL_PATTERN, 'i').test(subject);
}
